








































import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SortOrder } from '@/enums/SortOrder';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
  },
})
export default class PageAccount extends Searchable<PimAccount> {
  @Getter('account/all') accounts!: PimAccount[];

  @Getter('invite/all') invites!: Invite[];

  @Action('account/index') indexAccounts!: (payload: { query?: IndexQuery<PimAccount> }) => Promise<PimAccount[]>;

  @Action('invite/index') indexInvites!: (payload: { query?: IndexQuery<Invite> }) => Promise<Invite[]>;

  i18n: string = 'views.accounts.index';

  active: string = 'accounts';

  localAccounts: PimAccount[] = [];

  localInvites: Invite[] = [];

  searchItemsProperty = 'accounts';

  invitesSorting: { key: string; order: SortOrder } | null = null;

  tableLayoutAccounts = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 80px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: PimAccount) => `#${model.id}`,
        width: 75,
      },
      {
        key: 'email',
      },
      {
        key: 'first_name',
        value: (model: PimAccount) => `${model.first_name} ${model.last_name}`,
      },
      {
        key: 'locale',
        value: (model: PimAccount) => this.$t(`options.account_locale.${model.locale}`),
      },
      {
        key: 'role_names',
        value: (model: PimAccount) => model.role_names?.join(','),
      },
    ],
  };

  tableLayoutInvites = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 80px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Invite) => `#${model.id}`,
        width: 75,
      },
      {
        key: 'email',
        value: (model: any) => model.prefilled_data.email,
      },
      {
        key: 'prefilled_data.first_name',
        value: (model: any) => [model.prefilled_data.first_name, model.prefilled_data.last_name].filter((item) => item !== null || item !== undefined).join(' '),
      },
      {
        key: 'locale',
        value: (model: PimAccount) => this.$t(`options.account_locale.${model.locale}`),
      },
    ],
  };

  handleSort(item: any) {
    this.sorting = item;
    this.indexAccounts({ query: { per_page: 20, s: this.sortQuery } });
  }

  handleSortInvites(item: any) {
    this.invitesSorting = item;
    this.indexInvites({ query: { per_page: 20, s: this.inviteSortQuery } });
  }

  loadMoreAccounts() {
    this.indexAccounts({ query: { per_page: 20, after: this.lastAfter, s: this.sortQuery } });
  }

  loadMoreInvites() {
    this.indexInvites({ query: { per_page: 20, after: this.lastInviteAfter, s: this.inviteSortQuery } });
  }

  @Watch('accounts', { immediate: true })
  accountsChanged(val: PimAccount[]) {
    this.localAccounts = val;
  }

  @Watch('invites', { immediate: true })
  invitesChanged(val: Invite[]) {
    this.localInvites = val;
  }

  get inviteSortQuery() {
    if (this.invitesSorting === null) {
      return this.defaultSortQuery;
    }

    return { [this.invitesSorting.key]: this.invitesSorting.order };
  }

  get lastInviteAfter(): Array<string | number> {
    const total = this.accounts.length;
    const last: PimAccount = this.accounts[total - 1];
    if (last && last.sort) {
      return last.sort;
    }

    return [];
  }
}
